/**
 * Stripe mode helpers.
 *
 * Bank connection is gated on `stripeAccountId` in several places. Demo accounts never have one -
 * they have no Stripe presence at all - so every one of those checks has to know about Demo, or
 * the portal will keep asking a demo merchant to connect a bank account it can never connect.
 * Keep the logic here rather than repeating `mode !== 'Demo'` at each call site.
 */

interface ModeBearing {
  mode?: string;
  stripeAccountId?: string;
}

export const isDemo = (account?: ModeBearing | null): boolean => account?.mode === 'Demo';

/** True when the account still needs a Stripe bank connection. Never true for Demo. */
export const needsBankConnection = (account?: ModeBearing | null): boolean =>
  !account?.stripeAccountId && !isDemo(account);

/** True when the account has a usable Stripe connection (so a dashboard link makes sense). */
export const hasBankConnection = (account?: ModeBearing | null): boolean =>
  Boolean(account?.stripeAccountId) && !isDemo(account);
